import { faPalette } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Tooltip, Whisper } from 'rsuite';

export default function updateColor() {
    return (
        <div data-cy="historic-icon-updateColor">
            <Whisper
                placement="right"
                trigger="hover"
                speaker={
                    <Tooltip>
                        <FormattedMessage id="history.updateColor" />
                    </Tooltip>
                }>
                <FontAwesomeIcon icon={faPalette} size="lg" style={{ color: '#2184da' }} />
            </Whisper>
        </div>
    );
}
